import classNames from 'classnames';
import { Typography } from '../typography/typography';
import { Button } from '../form/button';
import { OrderWorkFlowStatus } from '../../clients/quipli-service/order/order';

const ORDER_TOGGLE_TABS: OrderWorkFlowStatus[] = [
  'Requests',
  'Approved',
  'On Rent',
  'Off Rent',
  'Completed',
  'Cancelled',
  'Quote',
  'Missed',
];

type TabNavRequest = {
  className?: string;
  selectedTabs: OrderWorkFlowStatus[];
  onSelect: (req: { workFlowStatus?: OrderWorkFlowStatus[] }) => void;
};

export const ToggleTabNav = ({ selectedTabs, onSelect, className }: TabNavRequest) => {
  const selectedAll = selectedTabs.length === 0;

  function onTabChange(tab: OrderWorkFlowStatus, action: 'add' | 'remove') {
    const allTabs = selectedAll ? [] : selectedTabs;
    let newTabs = action === 'add' ? [...allTabs, tab] : allTabs.filter((t) => t !== tab);

    if (newTabs.length === ORDER_TOGGLE_TABS.length) {
      newTabs = [];
    }

    onSelect({ workFlowStatus: newTabs });
  }

  function onAllTabChange() {
    if (selectedAll) {
      return;
    }

    onSelect({ workFlowStatus: undefined });
  }

  return (
    <div className={classNames('min-w-full mx-0 gap-[12px] flex items-left overflow-x-auto', className)}>
      <Button
        className={classNames({
          'button-tertiary': !selectedAll,
          'button-secondary !cursor-not-allowed': selectedAll,
        })}
        onClick={() => !selectedAll && onAllTabChange()}
      >
        <Typography type="text-sm">All</Typography>
      </Button>

      {ORDER_TOGGLE_TABS.map((tab, i) => {
        const isSelected = selectedTabs.includes(tab);
        const showAsSelected = isSelected || selectedAll;

        return (
          <Button
            key={i}
            className={classNames({
              'button-tertiary': !showAsSelected,
              'button-secondary': showAsSelected,
            })}
            onClick={() => onTabChange(tab, isSelected ? 'remove' : 'add')}
          >
            <Typography type="text-sm" className="whitespace-nowrap">
              {tab}
            </Typography>
          </Button>
        );
      })}
    </div>
  );
};
